import SafetyAssuredIcon from '../icons/SafetyAssuredIcon';
import SaveTimeIcon from '../icons/SaveTimeIcon';
import TransparentPricingIcon from '../icons/TransparentPricingIcon';

export function ProductAssurance() {
  return (
    <div className="bg-clay-100 p-12 md:p-24">
      <div className="mb-8 text-4xl text-acai-900">
        <span className="font-serif italic">Our</span> Assurance
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        <div className="flex flex-col gap-4">
          <div className="h-14 w-14">
            <SafetyAssuredIcon />
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-2xl md:text-3xl">
              Safety <span className="font-serif italic">Assured</span>
            </div>
            <div className="text-black/80">
              Our Beauty Consultants are 100% vaccinated and keep their masks on
              during the service to ensure your safety and comfort.
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="h-14 w-14">
            <TransparentPricingIcon />
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-2xl md:text-3xl">
              Transparent <span className="font-serif italic">Pricing</span>
            </div>
            <div className="text-black/80">
              In 2022, CASE recorded 1,441 customer complaints and consumer
              losses of $285,000 in the beauty industry. With no pricey upfront
              packages, we’re here to reshape the future of beauty.
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="h-14 w-14">
            <SaveTimeIcon />
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-2xl md:text-3xl">
              Save <span className="font-serif italic">Time</span>
            </div>
            <div className="text-black/80">
              The average woman spends 55 minutes getting ready and 40 minutes
              commuting. Save time by enjoying beauty at your doorstep.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
